const initialState = {
  // Email Settings
  domains: [],
  defaultFromAddress: "",
  defaultFromName: "",
  defaultReplyToAddress: "",
  defaultEmailHeader: "",
  emailHeaderDesign: null,
  development_mode: false,
  
  // UI State
  loading: false,
  saving: false,
  error: null,
  dirty: false,
  
  // Modal States
  showHeaderEditor: false,
  showInstructionsModal: false,
  showWarningModal: false,
  selectedDomain: null,
  
  // Original values for dirty checking
  originalDomains: [],
  originalDefaultFromAddress: "",
  originalDefaultFromName: "",
  originalDefaultReplyToAddress: "",
  originalDefaultEmailHeader: "",
  originalEmailHeaderDesign: null,
  originaldevelopment_mode: false,
};

const crmSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CRM_SETTINGS_LOADING":
      return {
        ...state,
        loading: true,
        error: null,
      };
      
    case "CRM_SETTINGS_LOADED":
      return {
        ...state,
        loading: false,
        domains: action.payload.domains || [],
        originalDomains: action.payload.domains || [],
        defaultFromAddress: action.payload.default_from_address || "",
        originalDefaultFromAddress: action.payload.default_from_address || "",
        defaultFromName: action.payload.default_from_name || "",
        originalDefaultFromName: action.payload.default_from_name || "",
        defaultReplyToAddress: action.payload.default_reply_to_address || "",
        originalDefaultReplyToAddress: action.payload.default_reply_to_address || "",
        defaultEmailHeader: action.payload.default_header_html || "",
        originalDefaultEmailHeader: action.payload.default_header_html || "",
        emailHeaderDesign: action.payload.default_header_design || null,
        originalEmailHeaderDesign: action.payload.default_header_design || null,
        development_mode: action.payload.development_mode || false,
        originaldevelopment_mode: action.payload.development_mode || false,
        dirty: false,
      };
      
    case "CRM_SETTINGS_LOAD_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      
    case "CRM_SETTINGS_SAVING":
      return {
        ...state,
        saving: true,
        error: null,
      };
      
    case "CRM_SETTINGS_SAVED":
      return {
        ...state,
        saving: false,
        domains: action.payload.domains || state.domains,
        originalDomains: action.payload.domains || state.domains,
        defaultFromAddress: action.payload.default_from_address || state.defaultFromAddress,
        originalDefaultFromAddress: action.payload.default_from_address || state.defaultFromAddress,
        defaultFromName: action.payload.default_from_name || state.defaultFromName,
        originalDefaultFromName: action.payload.default_from_name || state.defaultFromName,
        defaultReplyToAddress: action.payload.default_reply_to_address || state.defaultReplyToAddress,
        originalDefaultReplyToAddress: action.payload.default_reply_to_address || state.defaultReplyToAddress,
        defaultEmailHeader: action.payload.default_header_html || state.defaultEmailHeader,
        originalDefaultEmailHeader: action.payload.default_header_html || state.defaultEmailHeader,
        emailHeaderDesign: action.payload.default_header_design || state.emailHeaderDesign,
        originalEmailHeaderDesign: action.payload.default_header_design || state.emailHeaderDesign,
        development_mode: action.payload.development_mode || state.development_mode,
        originaldevelopment_mode: action.payload.development_mode || state.development_mode,
        dirty: false,
      };
      
    case "CRM_SETTINGS_SAVE_ERROR":
      return {
        ...state,
        saving: false,
        error: action.payload,
      };
      
    case "CRM_SETTINGS_UPDATE_DOMAINS":
      return {
        ...state,
        domains: action.payload,
        dirty: true,
      };
      
    case "CRM_SETTINGS_ADD_DOMAIN":
      return {
        ...state,
        domains: [...state.domains, { domain_name: action.payload, status: "new" }],
        dirty: true,
      };
      
    case "CRM_SETTINGS_REMOVE_DOMAIN":
      return {
        ...state,
        domains: state.domains.filter(domain => domain.domain_name !== action.payload),
        dirty: true,
      };
      
    case "CRM_SETTINGS_UPDATE_FIELD":
      return {
        ...state,
        [action.payload.field]: action.payload.value,
        dirty: true,
      };
      
    case "CRM_SETTINGS_SET_HEADER_EDITOR_OPEN":
      return {
        ...state,
        showHeaderEditor: action.payload,
      };
      
    case "CRM_SETTINGS_SET_INSTRUCTIONS_MODAL_OPEN":
      return {
        ...state,
        showInstructionsModal: action.payload,
      };
      
    case "CRM_SETTINGS_SET_WARNING_MODAL_OPEN":
      return {
        ...state,
        showWarningModal: action.payload,
      };
      
    case "CRM_SETTINGS_SET_SELECTED_DOMAIN":
      return {
        ...state,
        selectedDomain: action.payload,
      };
      
    case "CRM_SETTINGS_RESET_DIRTY":
      return {
        ...state,
        dirty: false,
      };
      
    case "CRM_SETTINGS_RESET_TO_ORIGINAL":
      return {
        ...state,
        domains: [...state.originalDomains],
        defaultFromAddress: state.originalDefaultFromAddress,
        defaultFromName: state.originalDefaultFromName,
        defaultReplyToAddress: state.originalDefaultReplyToAddress,
        defaultEmailHeader: state.originalDefaultEmailHeader,
        emailHeaderDesign: state.originalEmailHeaderDesign,
        development_mode: state.originaldevelopment_mode,
        dirty: false,
      };
      
    default:
      return state;
  }
};

export default crmSettingsReducer; 